import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import Login from "./components/login/Login";
import SignUp from "./components/reg/SignUp";
import NavBar from "./components/nav/Nav";
import flag from "./assets/Flag-Madagascar.webp";
import {
  FaClipboardList,
  FaFingerprint,
  FaMapMarkerAlt,
  FaQrcode,
  FaRegCheckCircle,
  FaShieldAlt,
  FaUserPlus,
  FaUsers,
} from "react-icons/fa";
import "./Start.css";

const StartView = ({ initialMode = "signin" }) => {
  const { t } = useTranslation();
  const [mode, setMode] = useState(initialMode);

  return (
    <div className="preenrollment-page">
      <NavBar activePage="home" />

      <main className="portal-hero" id="about">
        <section className="hero-copy" aria-labelledby="portal-heading">
          <div className="country-label">
            <img src={flag} alt="" />
            <span>{t("republic_of_madagascar")}</span>
          </div>
          <h1 id="portal-heading">
            {t("your_identity_today")} <span>{t("brighter_tomorrow")}</span>
          </h1>
          <p>
            {t("begin_digital_journey")}
          </p>
          <section
            className="how-it-works"
            aria-labelledby="how-it-works-heading"
          >
            <div className="how-it-works-heading">
              <span />
              <h2 id="how-it-works-heading">{t("how_it_works")}</h2>
            </div>
            <ol className="process-steps">
              <li className="process-step">
                <span className="process-icon">
                  <FaUserPlus />
                </span>
                <span className="process-copy">
                  <strong>{t("create_account")}</strong>
                  <small>{t("verify_account_otp")}</small>
                </span>
              </li>
              <li className="process-step">
                <span className="process-icon">
                  <FaClipboardList />
                </span>
                <span className="process-copy">
                  <strong>{t("add_details")}</strong>
                  <small>{t("submit_demographic")}</small>
                </span>
              </li>
              <li className="process-step">
                <span className="process-icon">
                  <FaQrcode />
                </span>
                <span className="process-copy">
                  <strong>{t("get_qr_code")}</strong>
                  <small>{t("take_to_centre")}</small>
                </span>
              </li>
              <li className="process-step">
                <span className="process-icon">
                  <FaMapMarkerAlt />
                </span>
                <span className="process-copy">
                  <strong>{t("complete_enrolment")}</strong>
                  <small>{t("track_status")}</small>
                </span>
              </li>
            </ol>
          </section>
        </section>
        <aside
          className={`signin-card ${mode === "signup" ? "signup-card" : ""}`}
          aria-label={
            mode === "signup"
              ? "Create a BioEnroll account"
              : t("sign_in_bioenroll")
          }
        >
          <h2>
            {mode === "signup" ? t("create_your_account") : t("sign_in_bioenroll")}
          </h2>
          <p>
            {mode === "signup"
              ? t("setup_preenrollment")
              : t("access_preenrollment")}
          </p>
          <div className="account-switcher">
            <button
              type="button"
              className={mode === "signin" ? "active" : ""}
              onClick={() => setMode("signin")}
            >
              {t("sign_in")}
            </button>
            <button
              type="button"
              className={mode === "signup" ? "active" : ""}
              onClick={() => setMode("signup")}
            >
              {t("create_account_btn")}
            </button>
          </div>
          {mode === "signup" ? (
            <SignUp onSwitchToSignIn={() => setMode("signin")} />
          ) : (
            <Login />
          )}
        </aside>
      </main>

      <section className="trust-bar" aria-label="BioEnroll commitments">
        <div>
          <FaFingerprint />
          <span>
            <strong>{t("secure_trusted")}</strong>
            <small>{t("data_protected")}</small>
          </span>
        </div>
        <div>
          <FaRegCheckCircle />
          <span>
            <strong>{t("easy_convenient")}</strong>
            <small>{t("preenrol_anytime")}</small>
          </span>
        </div>
        <div>
          <FaUsers />
          <span>
            <strong>{t("for_all_citizens")}</strong>
            <small>{t("simple_inclusive")}</small>
          </span>
        </div>
        <div>
          <FaShieldAlt />
          <span>
            <strong>{t("part_of_biosuite")}</strong>
            <small>{t("integrated_identity")}</small>
          </span>
        </div>
      </section>
    </div>
  );
};

export default StartView;
